import { infoLogger } from "./applicationLogUtils";

// Single source of truth for token-refresh state, shared by axiosExt and proactiveTokenRefresh
let _isRefreshing = false;
const _failedQueue: Array<{ resolve: (token: string) => void; reject: (err: any) => void }> = [];

export const getIsRefreshing = () => _isRefreshing;
export const setIsRefreshing = (v: boolean) => {
    _isRefreshing = v;
};

let _isLoggingOut = false;
export const getIsLoggingOut = () => _isLoggingOut;
export const setIsLoggingOut = (v: boolean) => { _isLoggingOut = v; };

export const enqueueRequest = (item: { resolve: (token: string) => void; reject: (err: any) => void }) => {
    _failedQueue.push(item);
};

export const processQueue = (error: any, token: string | null = null) => {
    const count = _failedQueue.length;
    _failedQueue.splice(0).forEach(({ resolve, reject }) => error ? reject(error) : resolve(token!));

};
